// Generated by Melange

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function Video(Props) {
  let closeVideo = Props.closeVideo;
  const rootWidth = (Number(document.getElementsByTagName('html')[0].clientWidth)
  );
  const width = rootWidth > 1279 ? 1280 : rootWidth;
  const height = Math.imul(width / 16 | 0, 9);
  const widthStr = String(width);
  const heightStr = String(height);
  React.useEffect((function () {
    ((new YT.Player('youtube_player', {
          height: '100%',
          width: '100%',
          videoId: 'DOtOOBPzfZQ',
          playerVars: {
            autoplay: 1,
            controls: 1,
            modestbranding: 1,
            rel: 0
          },
          events: {
            'onReady': event => event.target.playVideo(),
            'onStateChange': event => {if (event.data === 0) closeVideo()}
          }
        })
      ));
  }), []);
  return JsxRuntime.jsx(React.Fragment, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          id: "youtube_player"
        }),
        style: {
          height: heightStr + "px",
          width: widthStr + "px"
        }
      }),
      className: "fixed z-50 inset-0 bg-black/60 flex justify-center items-center",
      onClick: closeVideo
    })
  });
}

const make = Video;

export {
  make,
}
/* react Not a pure module */
